<template>
  <div class="mastery-schedule-form">
    <p class="mastery-schedule-form__intro mb-3">
      Vui lòng chọn thông tin ca thi cho khách hàng:
    </p>
    <el-form
      ref="masteryForm"
      class="entrance-exam-form"
      :model="testInput"
      :rules="formRules"
      label-position="top"
    >
      <div class="row">
        <div class="col-md-6">
          <el-form-item label="Trung tâm" prop="center_id">
            <el-select
              v-model="testInput.center_id"
              class="w-100 entrance-exam-select"
              :class="{ 'is-filled': testInput.center_id !== '' && testInput.center_id !== null && testInput.center_id !== undefined }"
              placeholder="Chọn trung tâm"
              filterable
              clearable
              popper-class="entrance-exam-select-dropdown"
              @change="handleCenterChange"
            >
              <el-option
                v-for="item in centerOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="col-md-6">
          <el-form-item label="Cơ sở" prop="branch_id">
            <el-select
              v-model="testInput.branch_id"
              class="w-100 entrance-exam-select"
              :class="{ 'is-filled': testInput.branch_id !== '' && testInput.branch_id !== null && testInput.branch_id !== undefined }"
              placeholder="Chọn cơ sở"
              filterable
              :loading="loadingBranch"
              popper-class="entrance-exam-select-dropdown"
              @change="changeBranchTestInput"
            >
              <el-option
                v-for="item in branchesTestInput"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="col-md-6">
          <el-form-item label="Hình thức" prop="hinh_thuc_test_dau_vao">
            <el-select
              v-model="testInput.hinh_thuc_test_dau_vao"
              class="w-100 entrance-exam-select"
              :class="{ 'is-filled': testInput.hinh_thuc_test_dau_vao !== '' && testInput.hinh_thuc_test_dau_vao !== null && testInput.hinh_thuc_test_dau_vao !== undefined }"
              placeholder="Chọn hình thức test"
              filterable
              popper-class="entrance-exam-select-dropdown"
              @change="changeHinhThucTestInput"
            >
              <el-option
                v-for="item in hinhThucTestDauVao"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="col-md-6">
          <el-form-item label="Giai đoạn học" prop="grade_level">
            <el-select
              v-model="testInput.grade_level"
              class="w-100 entrance-exam-select"
              :class="{ 'is-filled': testInput.grade_level !== '' && testInput.grade_level !== null && testInput.grade_level !== undefined }"
              placeholder="Chọn giai đoạn học"
              filterable
              popper-class="entrance-exam-select-dropdown"
              @change="emitTestInput"
            >
              <el-option
                v-for="item in gradeLevelOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="col-md-6">
          <el-form-item label="Ngày thi" prop="ngay_hen">
            <el-date-picker
              v-model="testInput.ngay_hen"
              class="w-100 entrance-exam-select"
              type="date"
              placeholder="Chọn ngày thi"
              format="dd-MM-yyyy"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="changeDataTestInput"
            />
          </el-form-item>
        </div>
        <div class="col-md-6">
          <el-form-item label="Giờ thi" prop="time">
            <el-select
              v-model="testInput.time"
              class="w-100 entrance-exam-select"
              :class="{ 'is-filled': testInput.time !== '' && testInput.time !== null && testInput.time !== undefined }"
              placeholder="Chọn giờ thi"
              filterable
              popper-class="entrance-exam-select-dropdown"
              :disabled="!testInput.ngay_hen"
              @change="changeHour"
            >
              <el-option-group
                v-for="group in testHourList"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                  :disabled="isDisableHour(item.label)"
                >
                  <span style="float: left">{{ item.label }}</span>
                  <span v-if="isHourTooBad(item.label)" class="text-danger" style="float: right; font-size: 11px;">
                    (Đông)
                  </span>
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { BRANCH_LIST, CENTER_LIST } from "@/core/services/store/customer/customer.module";
import { CHECK_SLOT_BY_DAY } from "@/core/services/store/customer/testInput.module";
import { TOEIC } from "@/core/config/center/centerOption";
import {
  Mentor_English_Mastery_ID,
  OFFLINE,
  ONLINE,
  TYPES
} from "@/core/config/testInput/testInputOption";
import { TIME_SELECT_OPTION_ONLINE } from "@/core/config/customer/selectTimeOption";
import {
  GRADE_LEVEL_OPTIONS,
  sanitizeGradeLevelPayload
} from "@/core/config/testInput/learningOption";

export default {
  name: "MasteryScheduleForm",
  props: {
    centerId: {
      type: [Number, String],
      required: true
    },
    centers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const gradeLevelValidator = (rule, value, callback) => {
      if (value === "" || value === null || value === undefined) {
        callback(new Error("Vui lòng chọn giai đoạn học"));
        return;
      }
      callback();
    };
    return {
      centersTestInput: [],
      branchesTestInput: [],
      hinhThucTestDauVao: TYPES,
      gradeLevelOptions: GRADE_LEVEL_OPTIONS,
      optionSelectTimeOnline: TIME_SELECT_OPTION_ONLINE,
      loadingBranch: false,
      allSlots: {},
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      testInput: {
        center_id: this.centerId,
        branch_id: "",
        hinh_thuc_test_dau_vao: "",
        ngay_hen: "",
        time: null,
        grade_level: ""
      },
      formRules: {
        center_id: [{ required: true, message: "Vui lòng chọn trung tâm", trigger: "change" }],
        branch_id: [{ required: true, message: "Cơ sở Test đầu vào là bắt buộc", trigger: "change" }],
        hinh_thuc_test_dau_vao: [{ required: true, message: "Vui lòng chọn hình thức", trigger: "change" }],
        grade_level: [{ validator: gradeLevelValidator, trigger: "change" }],
        ngay_hen: [{ required: true, message: "Vui lòng chọn ngày thi", trigger: "change" }],
        time: [{ required: true, message: "Vui lòng chọn giờ thi", trigger: "change" }]
      }
    };
  },
  computed: {
    testHourList() {
      return this.optionSelectTimeOnline;
    },
    centerOptions() {
      return this.centers.length ? this.centers : this.centersTestInput;
    }
  },
  watch: {
    centerId(val) {
      if (Number(val) !== Number(this.testInput.center_id)) {
        this.testInput.center_id = val;
        this.resetDependentFields();
        if (val) {
          this.getBranches();
        }
        this.emitTestInput();
      }
    }
  },
  mounted() {
    this.testInput.center_id = this.centerId;
    if (!this.centers.length) {
      this.getCenters();
    }
    this.getBranches();
    this.emitTestInput();
  },
  methods: {
    error(mess) {
      this.$alert(mess, "Thông báo", {
        confirmButtonText: "OK"
      });
    },
    resetDependentFields() {
      this.testInput.branch_id = "";
      this.testInput.hinh_thuc_test_dau_vao = "";
      this.testInput.ngay_hen = "";
      this.testInput.time = null;
      this.testInput.grade_level = "";
      this.branchesTestInput = [];
      this.allSlots = {};
    },
    handleCenterChange(val) {
      this.resetDependentFields();
      this.$emit("update:centerId", val);
      if (val && Number(val) === Number(Mentor_English_Mastery_ID)) {
        this.getBranches();
        this.emitTestInput();
      }
    },
    getCenters() {
      this.$store.dispatch(CENTER_LIST).then((response) => {
        if (response.status === 422) {
          return;
        }
        this.centersTestInput = response.data.filter(
          (center) => center.is_edutalk === 1 && center.id !== TOEIC
        );
      });
    },
    async getBranches() {
      if (!this.testInput.center_id) {
        this.branchesTestInput = [];
        return;
      }
      this.loadingBranch = true;
      try {
        const response = await this.$store.dispatch(BRANCH_LIST, {
          center_id: this.testInput.center_id
        });
        if (response.status !== 422) {
          this.branchesTestInput = response.data;
        }
      } finally {
        this.loadingBranch = false;
      }
    },
    disabledDate(date) {
      const tempDate = new Date();
      const currentDate = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate(), 0, 0);
      const dayOfWeek = tempDate.getDay() === 0 ? 7 : tempDate.getDay();
      const nextWeek = new Date(
        tempDate.getFullYear(),
        tempDate.getMonth(),
        tempDate.getDate() + (7 - dayOfWeek)
      );
      return date < currentDate || date > nextWeek;
    },
    checkSlotByDay() {
      if (
        this.testInput.hinh_thuc_test_dau_vao == undefined ||
        this.testInput.hinh_thuc_test_dau_vao === null ||
        this.testInput.hinh_thuc_test_dau_vao === '' ||
        !this.testInput.branch_id
      ) {
        return;
      }
      const dayMoment = this.testInput.ngay_hen ? moment(this.testInput.ngay_hen) : null;
      if (!dayMoment || !dayMoment.isValid()) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const payload = {
        branch_id: this.testInput.branch_id,
        day: dayMoment.format("YYYY-MM-DD"),
        type: this.testInput.hinh_thuc_test_dau_vao,
        band_type: 2
      };
      this.$store
        .dispatch(CHECK_SLOT_BY_DAY, payload)
        .then((data) => {
          const Hour = { ...data.data };
          Object.keys(data.data).forEach((key) => {
            Hour[key] = Hour[key]?.type ?? 0;
          });
          const selectedDay = moment(this.testInput.ngay_hen).format("YYYY-MM-DD");
          const today = moment().format("YYYY-MM-DD");
          const isOverTime =
            selectedDay < today || (selectedDay === today && moment().format("HH:mm") > "20:00");
          this.allSlots = Hour;
          const valueHour = Object.values(Hour);
          if (valueHour.filter((e) => e == 0).length == valueHour.length || isOverTime) {
            this.allSlots = {};
            this.error(
              this.testInput.hinh_thuc_test_dau_vao == OFFLINE
                ? "Không có admin test trực tại điểm."
                : "Ngày chọn đã hết ca trống. Vui lòng chọn ngày khác hoặc liên hệ hotline 0823185694 để đề xuất thêm ca test."
            );
          }
        })
        .catch(() => {
          this.error(
            this.testInput.hinh_thuc_test_dau_vao == OFFLINE
              ? "Không có admin test trực tại điểm."
              : "Ngày chọn đã hết ca trống. Vui lòng chọn ngày khác hoặc liên hệ hotline 0823185694 để đề xuất thêm ca test."
          );
          this.allSlots = {};
        })
        .finally(() => {
          loading.close();
        });
    },
    isDisableHour(hour) {
      if (!this.allSlots || Object.keys(this.allSlots).length == 0) {
        return true;
      }
      const stringHour = `${this.testInput.ngay_hen} ${hour}`;
      return (
        new Date(stringHour).getTime() < new Date().getTime() ||
        this.allSlots[hour] == 0 ||
        (this.allSlots[hour] == 2 && this.testInput.hinh_thuc_test_dau_vao == ONLINE)
      );
    },
    isHourTooBad(hour) {
      const stringHour = `${this.testInput.ngay_hen} ${hour}`;
      return (
        new Date(stringHour).getTime() > new Date().getTime() &&
        this.allSlots[hour] == 2 &&
        this.testInput.hinh_thuc_test_dau_vao == OFFLINE
      );
    },
    changeBranchTestInput() {
      this.testInput.time = null;
      this.testInput.ngay_hen = null;
      this.emitTestInput();
    },
    changeHinhThucTestInput() {
      this.testInput.time = null;
      this.testInput.ngay_hen = null;
      this.emitTestInput();
    },
    changeDataTestInput() {
      this.testInput.time = null;
      this.emitTestInput();
      this.checkSlotByDay();
    },
    changeHour() {
      this.emitTestInput();
    },
    emitTestInput() {
      const payload = sanitizeGradeLevelPayload({
        payload: { ...this.testInput },
        isMastery: Number(this.testInput.center_id) === Number(Mentor_English_Mastery_ID)
      });
      this.$emit("infoTestInput", payload);
    },
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.masteryForm.validate((valid) => {
          if (valid) {
            this.emitTestInput();
          }
          resolve(valid);
        });
      });
    },
    getPayload() {
      return sanitizeGradeLevelPayload({
        payload: { ...this.testInput },
        isMastery: true
      });
    }
  }
};
</script>

<style scoped>
.mastery-schedule-form__intro {
  color: #48454f;
  font-size: 14px;
  line-height: 1.35;
}

.entrance-exam-form >>> .el-form-item__label::before {
  color: #e03131;
  content: "* ";
}
</style>
